import { render, staticRenderFns } from "./Cores.vue?vue&type=template&id=3d1a488e&scoped=true&"
import script from "./Cores.vue?vue&type=script&lang=js&"
export * from "./Cores.vue?vue&type=script&lang=js&"
import style0 from "./Cores.vue?vue&type=style&index=0&id=3d1a488e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1a488e",
  null
  
)

export default component.exports